var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center align-center",staticStyle:{"min-height":"55px"}},[_vm._v(" "+_vm._s(_vm.primary)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }